<template>
  <div class="progress chart-progress" v-loading="!init">
    <div class="chart" v-if="init" style="padding-bottom: 120px">
      <h3>Итого численность</h3>
      <div class="chart-container" style="margin-top: 14px">
        <div>
          <line-chart :width="size" :height="250" :chart-data="chartData" :options="chartOptions"></line-chart>
        </div>
      </div>
      <div class="labels-custom" style="margin-left: 24px; display: flex; align-items: center">
        <span class="strong">План средняя: {{ stat.planAvg }}</span>
        <span class="strong">Факт средняя: {{ stat.factAvg }}</span>
        <span class="strong red" :style="{color: pStatus(stat.percentagePlan), 'font-size': '24px', 'font-weight': 'bold'}"> {{ stat.percentagePlan }}%</span>

      </div>


      <div style="margin-bottom: 0px" v-for="comp in companies" :key="comp.label">
        <div style="display: flex; justify-content: center; flex: 1; width: 100%; margin-top: 30px">
          <strong class="label-chart" style="margin-bottom: 10px; text-align: center;">{{ comp.label }}</strong>
        </div>
        <div class="chart-container">
          <line-chart :width="size" :height="250"
                      v-if="init"
                      :chart-data="comp.chartData"
                      :options="chartOptions">
          </line-chart>
        </div>
        <div class="labels-custom" style="display: flex; align-items: center; margin-left: 20px">
          <span class="strong">План средняя: {{ comp.stat.planAvg }}</span>
          <span class="strong">Факт средняя: {{ comp.stat.factAvg }}</span>
          <span class="strong red" :style="{color: pStatus(comp.stat.percentagePlan), 'font-size': '24px', 'font-weight': 'bold'}"> {{ comp.stat.percentagePlan }}%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import BarChart from "./BarChart";
import LineChart from "./LineChart";
import {numberWithSpaces, toFixedWithoutZero} from "../../../utils/numberUtils";
import {isApiRuleIgnore} from "../../../plugins/firebase";

export default {
  name: "Population",
  components: {LineChart},
  data() {
    return {
      type: 'Исполнители',
      init: false,
      isCurrentPlan: false,
      stat: {},
      headCount: {},
      size: this.getSize(),
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'План',
            backgroundColor: 'rgba(0,0,0,0)',
            borderColor: '#f28a43',
            data: []
          },
          {
            label: 'Факт',
            backgroundColor: 'rgba(0,0,0,0)',
            borderColor: '#34a4dc',
            data: []
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            ticks: {
              fontSize: 10
            }
          }]
        }
      }
    }
  },
  async mounted() {
    await this.getAnalytics();
  },
  computed: {
    companies() {
      if (!this.headCount || !this.headCount.items) {
        return []
      }

      return Object.entries(this.headCount.items).map(([key, obj]) => {

        return ({
          label: key,
          stat: {
            planAvg: obj.planAvg,
            factAvg: obj.factAvg,
            percentagePlan: obj.percentagePlan,
          },
          chartData: {
            labels: this.chartData.labels,
            datasets: [
              {
                label: 'План',
                backgroundColor: 'rgba(0,0,0,0)',
                borderColor: '#f28a43',
                data: Object.values(obj.planByDate)
              },
              {
                label: 'Факт',
                backgroundColor: 'rgba(0,0,0,0)',
                borderColor: '#34a4dc',
                data: Object.values(obj.factByDate)
              }
            ]
          }
        })
      });
    },
  },
  watch: {
    isCurrentPlan() {
      this.getAnalytics();
    },
    type() {
      this.getAnalytics(this.type === 'Объекты');
    }
  },
  methods: {
    numberWithSpaces,
    toFixedWithoutZero,
    getSize() {
      const size = window.screen.width;

      if(size < 460) {
        return size - 20;
      }

    },
    async getAnalytics() {
      setTimeout(async () => {
        this.init = false

        let url = `onAggregateHeadcount/${this.$store.state.project.id}&queryParams=uid=${authFirestore.currentUser.uid}`

        if(isApiRuleIgnore) {
          url =  `onAggregateHeadcount/${this.$store.state.project.id}?uid=${authFirestore.currentUser.uid}`
        }

        if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
          if(isApiRuleIgnore) {
            url += `&planId=${this.$store.state.project.plan.id}`

          } else {
            url += `, planId=${this.$store.state.project.plan.id}`
          }
        }

        if (isApiRuleIgnore) {
          url = url.replace('&queryParams=', '?').replace(/, /g, "&")
        }

        const proxy = firebase.functions().httpsCallable(
          url
        );
        const {data} = await proxy(
          {
            uid: authFirestore.currentUser.uid,
            planId: (this.$store.state.project.plan && this.$store.state.project.plan.id) || null,
            isCurrentPlan: this.isCurrentPlan
          },
        );

        this.chartData.labels = data.headcount.dates;
        this.headCount = data.headcount;
        this.chartData.datasets = [
          {
            label: 'План',
            backgroundColor: 'rgba(0,0,0,0)',
            borderColor: '#f28a43',
            data: Object.values(data.headcount.planByDate)
          },
          {
            label: 'Факт',
            backgroundColor: 'rgba(0,0,0,0)',
            borderColor: '#34a4dc',
            data: Object.values(data.headcount.factByDate)
          }
        ]

        this.stat = {
          planAvg: data.headcount.planAvg,
          factAvg: data.headcount.factAvg,
          percentagePlan: data.headcount.percentagePlan,
        }


        // this.analytics.priceJobs = data.priceJobs;
        //
        // let fact = this.analytics.priceJobs.plan ? this.analytics.priceJobs.percentagePlan : 100
        // let parse = [this.analytics.priceJobs.plan ? 100 : 0, fact || 0];
        //
        // if(!this.analytics.priceJobs.plan && !this.analytics.priceJobs.fact) {
        //   parse = [0,0]
        // }
        //
        // this.chartData.datasets[0].data = [parse[0], parse[1]]
        // this.chartData.labels = [`План ${parse[0]}`, `Факт ${parse[1]}`];
        this.init = true
      }, 1000)
    },
    pStatus(n) {
      if (n >= 99) {
        return '#7CB342'
      }

      if (n > 70) {
        return '#F57C00'
      }

      return '#D32F2F'
    }
  }
}
</script>

<style scoped lang="scss">
.progress {
  max-width: 600px;
  margin: 0 auto;
  // IOS ONLY REMOVE
  margin-top: -25px;

  .chart {
    margin: 0 auto;
    max-width: 460px;
    overflow: hidden;

    .percent {
      font-size: 18px;
      width: 100px;
      padding-left: 10px;
    }

    .chart-container {
      display: flex;
      align-items: center;
    }
  }
}

.chart-container-companies {
  min-width: 360px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  .chart-company {
  }

}

.labels-custom {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  flex: 1;
  width: 100%;
  text-align: center;

  span {
    color: #000;
    font-size: 13px;
    margin-top: 12px;
    margin-right: 20px;
  }
}

.strong {
  font-weight: bold;
}


.label-chart {
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: calc(100% - 60px);
}
</style>
<style lang="scss">
.chart-progress {
  .el-radio-button__inner {
    width: 100px !important;
    padding: 12px 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Analytics/Population.vue